import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const listCards = () => axios.get(`${API}/cards`).then((r) => r.data);
export const createCard = (data) =>
  axios.post(`${API}/cards`, data).then((r) => r.data);
export const updateCard = (id, data) =>
  axios.put(`${API}/cards/${id}`, data).then((r) => r.data);
export const deleteCard = (id) =>
  axios.delete(`${API}/cards/${id}`).then((r) => r.data);
